<!-- A disabled button swallows the hover its tooltip needs, so an unusable carrier is aria-disabled instead. -->
<button
  pButton
  type="button"
  data-cy="load"
  size="small"
  class="online-carrier-button"
  [severity]="severity()"
  [disabled]="loading() || disabled()"
  [attr.aria-disabled]="loadable() ? null : true"
  [pTooltip]="tooltip()"
  (click)="onClick()"
>
  {{ loading() ? loadingLabel() : label() }}
  @if (icon(); as icon) {
    <i class="pi" [class]="icon" aria-hidden="true"></i>
  }
</button>
